export default __webpack_public_path__ + "static/geetajayanti1-e5daa64acbc963b8aa7f224a94759ecd.jpg";